export default __webpack_public_path__ + "static/media/folder.496905fb.svg";